export const sanitizeArrowsAiInstructions = text => {
  if (!text) return text;

  return text
    .replace(/\[([^[\]]+)\]\(mailto:([^)]+)\)/gi, (_match, label, email) =>
      String(label).toLowerCase() === String(email).toLowerCase()
        ? email
        : label
    )
    .replace(/<(https?:\/\/[^>\s]+)>/gi, '$1')
    .replace(/<mailto:([^>]+)>/gi, '$1')
    .replace(/\[(https?:\/\/[^[\]]+)\]\(\1\)/gi, '$1')
    .replace(/\\[ \t]*$/gm, '');
};
